
import { enUS } from "date-fns/locale";

import { Chart, registerables } from "chart.js";

import 'chartjs-adapter-date-fns';
import { GlobalVariablesService } from "../../services/global-variables.service";

export class ChartJsEnergyOverallGraph {

    graph: any;

    constructor(private globalVars: GlobalVariablesService) {
    
    }

    draw(data: any[]) {
        Chart.register(...registerables);


        let values = [];

        for(let i in data){
       
            values.push({
                x: data[i].timestamp,
                y: data[i].value
            });
        }

        this.graph = new Chart("energyOverallGraph", {
            type: 'bar',
            data: {
                datasets: [{
                    data: values,
                    backgroundColor: '#0E8E75',
                    borderColor: '#0E8E75',
                  
                }],
            },
            options: {
                
                scales: {
                    
                    x: {
                        bounds: 'ticks',
                        type: 'time',
                        adapters: {
                            date: {
                                locale: enUS
                            },

                        },
                        time: {
                            unit: 'day',
                        }
                    },
                    y: {
                        ticks: {
                            callback: (value, index, values) => {
                                return value + 'kwH';
                            }
                        }
                    }
                },
               
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: "Average Energy Usage Overall",
                    },
                    tooltip: {
                        callbacks: {
                            label: (point) => {
                                let value = point.parsed.y;
                                return " Energy Usage " + value + "kWH";
                            },
                            footer: (point) => {
                                let value = point[0].parsed.y;
                                let tarrif = this.globalVars.getTarrif();
                                return "Cost: £" + (value * tarrif).toFixed(2);
                            },
                            title: (point) => {
                                let value = point[0].parsed.x;
                                const dateString = new Date(value).toLocaleDateString();
                                return dateString;
                            }
                        }
                    },

                }


            },
        });
        this.graph.canvas.parentNode.style.height = '150px';

    }

}